import React from 'react';
import Help from '../../components/Help';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function HelpPage() {
  return (
    <PageLayout title="Ajuda" subtitle="Suporte e documentação" primary={<Help />} secondary={null} />
  );
}

export default HelpPage;
